import PropTypes from "prop-types";

import { MONTH_DATE_YEAR_FORMAT } from "utils/date";
import { getHpLineColors } from "features/Strategy/utils";
import { GradientLineChart } from "shared";

const StrategyPredictionChart = ({ chart = [], height = "250px" }) => {
  const assetsColors = getHpLineColors(chart);

  return (
    <GradientLineChart
      title=""
      gridVertical
      fillOpacity={1}
      showDot
      data={chart.slice(-50)}
      assetsColors={assetsColors}
      timestamp={MONTH_DATE_YEAR_FORMAT}
      percentageVal={false}
      height={height}
    />
  );
};

StrategyPredictionChart.propTypes = {
  chart: PropTypes.array,
  height: PropTypes.string,
};

export { StrategyPredictionChart };
